import { render, staticRenderFns } from "./OrganizationPacketGuard.vue?vue&type=template&id=1bba2cf0&"
import script from "./OrganizationPacketGuard.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPacketGuard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports